<template lang="pug">
  div(v-loading="loading")
    div(class="grid grid-template-columns" v-if="hasGaleria")
      div(v-for="(img, index) in srcList" :key="index")
        el-image(
          style='width: 190px; height: 130px'
          :preview-src-list="srcList"
          :src="img"
        )
    div(class="center" v-else)
      app-divider(label="Fotos", :addMarginTop="false")
      p.mt-10 Não há dados para serem exibidos.
    listagem-documentos(
      v-if="imovel.documentos && imovel.documentos.length > 0"
      :documentosColetivoisReurb="documentosColetivoisReurb",
      :documentos="imovel.documentos",
      :protocoloCadastroOriginal="protocolo"
      ownerDocumento="IMOVEL",
      :isDetalhes="true",
      :interessado="interessado",
      :tempoOcupacao="imovel.tempoOcupacao"
      :addMarginTop="false"
      :compararDocumentos="compararGaleria.mudouDocumentosImovel"
      :versaoCadastro="versaoCadastro"
    )

</template>

<script>
import ListagemDocumentos from './ListagemDocumentos'
import AppDivider from '@/components/AppDivider'

export default {
  components: {
    ListagemDocumentos,
    AppDivider
  },
  props: {
    loading: {
      required: false
    },
    srcList: {
      type: Array,
      required: true
    },
    imovel: {
      required: true
    },
    interessado: {
      required: true
    },
    protocolo: {
      required: true
    },
    compararGaleria: {
      type: Object,
      required: false
    },
    versaoCadastro: {
      type: String
    },
    documentosColetivo: {
      type: Array,
      required: false
    }
  },

  computed: {
    hasGaleria () {
      return this.srcList?.length > 0
    },
    documentosColetivoisReurb () {
      const docsCRF = this.documentosColetivo?.filter(doc => doc.tipo.codigo === 'CRF') || []
      return docsCRF.length ? [docsCRF[docsCRF.length - 1]] : []
    }
  }
}
</script>
<style lang="scss"  scoped>

  .center {
    text-align: center;
  }

  .grid {
    display: grid;
    max-width: 1000px;
    margin: 10px 0 10px 0;
  }

  .grid-template-columns {
    grid-template-columns: 200px 200px 200px 200px 200px;
  }

  .mt-10 {
    margin-top: 10px !important;
  }
  >>> .text .text{
    color: #ff0000 !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/Galeria.vue